import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { BaseFieldProps } from 'SharedComponents/Fields/composables/useBaseFieldProps';
import useFileApi from 'SharedDir/common/composables/useFileApi';
import { PictureFieldParams } from 'SharedDir/declarations/fields';
import { computed, onMounted, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'PictureField' },
  __name: 'Picture',
  props: {
    label: { default: '' },
    showHistory: { type: Boolean },
    history: {},
    params: {}
  },
  setup(__props: any) {



const props = __props;

const { getBase64Content } = useFileApi();

const srcContent = ref<string | ArrayBuffer | null>('');

const getSrcContent = async (id: string | null) => {
  if (!id) return;
  srcContent.value = await getBase64Content(id);
};

watch(
  () => props.params.fileId,
  (newFileId) => {
    getSrcContent(newFileId);
  }
);

onMounted(() => {
  getSrcContent(props.params.fileId);
});

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!

  return (_openBlock(), _createBlock(_component_q_img, {
    width: "200px",
    src: srcContent.value,
    alt: _ctx.params.alt
  }, null, 8, ["src", "alt"]))
}
}

})